import { Card, CardBody } from "reactstrap";
import { Bar } from 'react-chartjs-2';
import { backgroundColorList } from "services/Utils";
import { borderColorList } from "services/Utils";

export default function PorPrioridade({ dados }) {
  return (
    <Card className="mt-4">
      <CardBody>

        <Bar
          data={{
            labels: dados.map(el => el.prioridade),
            datasets: [
              {
                label: "Pendentes",
                data: dados.map(el => el.pendentes),
                backgroundColor: backgroundColorList[0],
                borderColor: borderColorList[0],
                borderWidth: 1,
              },
              {
                label: "Em Execução",
                data: dados.map(el => el.emExecucao),
                backgroundColor: backgroundColorList[1],
                borderColor: borderColorList[1],
                borderWidth: 1,
              },
              {
                label: "Em Fiscalização",
                data: dados.map(el => el.emFiscalizacao),
                backgroundColor: backgroundColorList[2],
                borderColor: borderColorList[2],
                borderWidth: 1,
              },
              {
                label: "Em Correação",
                data: dados.map(el => el.emCorrecao),
                backgroundColor: backgroundColorList[3],
                borderColor: borderColorList[3],
                borderWidth: 1,
              },
              {
                label: "Finalizadas",
                data: dados.map(el => el.finalizadas),
                backgroundColor: backgroundColorList[4],
                borderColor: borderColorList[4],
                borderWidth: 1,
              },
            ]
          }}
          options={{
            title: {
              display: true,
              text: "Ordens de Serviço por Prioridade"
            },
            scales: {
              xAxes: [
                { stacked: true }
              ],
              yAxes: [
                { stacked: true }
              ]
            }
          }}
        />


      </CardBody>
    </Card>
  )
}